import { Check, X } from "lucide-react";
import { SectionHeader, BodyText } from "@/components/ui/typography";

const comparisons = [
  {
    aspect: "Feedback Frequency",
    traditional: "Yearly or quarterly surveys",
    sendfeedback: "Always-on, continuous feedback",
  },
  {
    aspect: "True Anonymity",
    traditional: "\"Anonymous\" with tracking cookies",
    sendfeedback: "No IP, no login, no tracking—guaranteed",
  },
  {
    aspect: "Time to Insights",
    traditional: "Weeks of manual analysis",
    sendfeedback: "Instant AI-powered analysis",
  },
  {
    aspect: "Problem Detection",
    traditional: "After issues escalate",
    sendfeedback: "Early warning system with alerts",
  },
  {
    aspect: "HR Response Guidance",
    traditional: "None included",
    sendfeedback: "Built-in templates & legal guidance",
  },
  {
    aspect: "Setup Time",
    traditional: "Weeks with consultants",
    sendfeedback: "5 minutes, no IT needed",
  },
];

export const ComparisonTable = () => {
  return (
    <section className="bg-muted/30 py-12 md:py-16">
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto space-y-8 md:space-y-12">
          <div className="text-center space-y-2 max-w-3xl mx-auto">
            <SectionHeader className="text-foreground">
              SendFeedback vs Traditional Surveys
            </SectionHeader>
            <BodyText className="text-muted-foreground">
              See why continuous anonymous feedback beats annual engagement surveys
            </BodyText>
          </div>

          {/* Desktop Table */}
          <div className="hidden md:block overflow-hidden rounded-xl border border-border bg-card">
            <table className="w-full">
              <thead>
                <tr className="border-b border-border bg-muted/50">
                  <th className="text-left p-4 font-semibold text-foreground">
                    Feature
                  </th>
                  <th className="text-left p-4 font-semibold text-muted-foreground">
                    Traditional Surveys
                  </th>
                  <th className="text-left p-4 font-semibold text-primary bg-primary/5">
                    SendFeedback
                  </th>
                </tr>
              </thead>
              <tbody>
                {comparisons.map((row, index) => (
                  <tr
                    key={row.aspect}
                    className={index !== comparisons.length - 1 ? "border-b border-border" : ""}
                  >
                    <td className="p-4 font-medium text-foreground">
                      {row.aspect}
                    </td>
                    <td className="p-4 text-muted-foreground">
                      <div className="flex items-start gap-2">
                        <X className="h-5 w-5 text-destructive flex-shrink-0 mt-0.5" />
                        <span>{row.traditional}</span>
                      </div>
                    </td>
                    <td className="p-4 bg-primary/5">
                      <div className="flex items-start gap-2">
                        <Check className="h-5 w-5 text-primary flex-shrink-0 mt-0.5" />
                        <span className="text-foreground font-medium">
                          {row.sendfeedback}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Mobile Cards */}
          <div className="md:hidden space-y-4">
            {comparisons.map((row) => (
              <div
                key={row.aspect}
                className="rounded-xl border border-border bg-card p-4 space-y-3"
              >
                <h4 className="font-semibold text-foreground">{row.aspect}</h4>
                <div className="space-y-2">
                  <div className="flex items-start gap-2 text-sm">
                    <X className="h-4 w-4 text-destructive flex-shrink-0 mt-0.5" />
                    <div>
                      <span className="text-muted-foreground text-xs block">
                        Traditional
                      </span>
                      <span className="text-muted-foreground">
                        {row.traditional}
                      </span>
                    </div>
                  </div>
                  <div className="flex items-start gap-2 text-sm bg-primary/5 -mx-4 px-4 py-2">
                    <Check className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                    <div>
                      <span className="text-primary text-xs block font-medium">
                        SendFeedback
                      </span>
                      <span className="text-foreground font-medium">
                        {row.sendfeedback}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
